module.exports = __webpack_public_path__ + "img/cloth_g3_hat-08.6ee5bcb4.svg";